module.exports = __webpack_public_path__ + "img/0Q3A2940_L.843511ce.webp";